let feeProducts = {
  running: false,
  cartItems: document.querySelector('cart-items'),

  init() {
    this.bindEvents();
    this.initCheck();
  },

  bindEvents() {
    let _this = this;

    let events = ['on:cart:add', 'cart:item-remove', 'on:line-item:quantity', 'on:line-item:change'];
    events.forEach(event => {
      document.addEventListener(event, (e) => {
        _this.initCheck();
      });
    })

  },

  initCheck() { 
    let _this = this;
    // Enable loading state
    _this.enableLoading();

    // Pipe fee product add to cart
    fetch('/cart?view=verify-pipefee').then(res => res.json()).then(response => {
      this.checkCartForPipeFeeProduct(response);
    });
  },

  addFeeProductToCart(id, targetItemKey, skipProps = false) {
    let _this = this;
    // Enable loading state
    _this.cartItems.enableLoading();

    let data = {
      quantity: 1,
      id: id,
      properties: skipProps ? {} : {
        '_is_fee_product': true,
        '_target_item_key': targetItemKey
      },
      // sections: _this.cartItems.getSectionsToRender().map((section) => section.id),
    };
    fetch('/cart/add.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then(response => {
      // Sections rendering
      // _this.cartItems.renderContents(response);

      setTimeout(() => {
        _this.cartItems.refresh( false );

        // Disable loading state
        _this.disableLoading();
      }, 500);

      document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));

      document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false }));
      if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
        location.reload();
      }
      _this.running = false;
    });
  },

  updateItemQty(id, qty = 1) {
    let _this = this;
    // Enable loading state
    _this.cartItems.enableLoading();

    fetch('/cart/change.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id, 
        quantity: qty, 
        // sections: _this.cartItems.getSectionsToRender().map((section) => section.id)
      })
    })
    .then((response) => response.json())
    .then(response => {
      // Sections rendering
      // _this.cartItems.renderContents(response);
      // Disable loading state
      _this.disableLoading();

      _this.cartItems.refresh( false );

      if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
        location.reload();
      }
      _this.running = false;
    });
  },

  // Pipe fee product
  checkCartForPipeFeeProduct(data) {
    let _this = this;

    // Disable loading state
    _this.disableLoading();

    // Check if we should remove the fee
    if ( data.should_remove_fee ) {
      _this.updateItemQty(data.pipefee_item_key, 0);
      return;
    }
    
    if ( data.pipefee_item_qty > 1 ) {
      _this.updateItemQty(data.pipefee_item_key, 1);
      return;
    }

    // add fee product if required
    if ( data.should_apply_fee == true && window.theme.pipeFeeProductId ) {
      // Enable loading state
      _this.cartItems.enableLoading();
      
      _this.addFeeProductToCart(window.theme.pipeFeeProductId, '', true);
    }

  },

  // Disable loading state
  disableLoading() {
    // Enable Checkout Button
    var checkoutBtn = document.querySelector('[name="checkout"]');
    if( checkoutBtn ) {
      checkoutBtn.disabled = false;
    }

    var dynamicCheckoutEl = document.querySelectorAll('.dynamic-cart-btns');
    if( dynamicCheckoutEl ) {
      dynamicCheckoutEl.forEach( el => {
        el.classList.remove('disabled');
      });
    }

    let cartItems = document.querySelector('cart-items');
    if (!cartItems) return;
    
    cartItems.classList.remove('pointer-events-none');
    const loader = cartItems.querySelector('.cart-item__loader');
    if (loader) loader.hidden = true;
    document.activeElement.blur();
    if (cartItems.itemStatus) cartItems.itemStatus.setAttribute('aria-hidden', 'true');
  },

  // Enable loading state
  enableLoading() {
    // Enable Checkout Button
    var checkoutBtn = document.querySelector('[name="checkout"]');
    if( checkoutBtn ) {
      checkoutBtn.disabled = true;
    }

    var dynamicCheckoutEl = document.querySelectorAll('.dynamic-cart-btns');
    if( dynamicCheckoutEl ) {
      dynamicCheckoutEl.forEach( el => {
        el.classList.add('disabled');
      });
    }

  },

}

feeProducts.init();